import { Mic, MicOff } from "lucide-react";
import { useShallow } from "zustand/react/shallow";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import { getCurrentParticipant } from "../api/get-current-participant";
import { useIsModerator } from "../api/is-moderator";
import {
  useMuteParticipantAudio,
  useUnmuteParticipantAudio,
} from "../api/mute-participant-audio";

export function ToggleAllMic() {
  const isModerator = useIsModerator();
  const sessionId = useVidyoStore((state) => state.sessionId);
  const isAllMuted = useVidyoStore(
    useShallow((state) =>
      state.participants.participants.every(
        (participant) =>
          participant.isCurrentUser || !participant.isAudioEnabled,
      ),
    ),
  );
  const currentParticipant = getCurrentParticipant();

  const {
    mutate: muteParticipantsAudio,
    isPending: isMutatingMuteParticipantsAudio,
  } = useMuteParticipantAudio();
  const {
    mutate: unmuteParticipantsAudio,
    isPending: isMutatingUnmuteParticipantsAudio,
  } = useUnmuteParticipantAudio();

  const isLoading =
    isMutatingMuteParticipantsAudio || isMutatingUnmuteParticipantsAudio;

  const handleMuteAllParticipants = () => {
    muteParticipantsAudio({
      sessionId: sessionId,
      body: {
        isApplyingActionToAll: true,
        participantId: currentParticipant?.participantId,
      },
    });
  };

  const handleUnmuteAllParticipants = () => {
    unmuteParticipantsAudio({
      sessionId: sessionId,
      body: {
        isApplyingActionToAll: true,
        participantId: currentParticipant?.participantId,
      },
    });
  };

  const handleButtonClick = isAllMuted
    ? handleUnmuteAllParticipants
    : handleMuteAllParticipants;

  if (!isModerator) {
    return null;
  }

  return (
    <>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleButtonClick}
            disabled={isLoading}
            isLoading={isLoading}
          >
            <MicOff className="size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Disable all microphones</p>
        </TooltipContent>
      </Tooltip>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleButtonClick}
            disabled={isLoading}
            isLoading={isLoading}
          >
            <Mic className="size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Enable all microphones</p>
        </TooltipContent>
      </Tooltip>
    </>
  );
}
